// extracted by mini-css-extract-plugin
module.exports = {"hover":"style_hover__mSfWC"};